export const FETCH_USER_BOOKINGS = 'userBookings/FETCH_USER_BOOKINGS'
export const USER_BOOKING_SUCCESS = 'userBookings/USER_BOOKING_SUCCESS'
export const USER_BOOKING_ERROR = 'userBookings/USER_BOOKING_ERROR'
export const CLEAR_USER_BOOKINGS = 'userBookings/CLEAR_USER_BOOKINGS'
export const SHOW_NON_REFUNDED = 'userBookings/SHOW_NON_REFUNDED'
// TODO: This should be a label
export const DEFAULT_FETCH_BOOKINGS_ERROR = 'Unable to fetch bookings'
